// @flow
import Grid from "@mui/material/Grid2";
import React from 'react';
import { IconButton } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import TrashIcon from "../../../../../../assets/images/icons/buttons/trashIcon";
import RowInputs from "./rowInputs";

type Props = {};

const Row = (props: Props) => {
	const {
		row,
		rows,
		onUpdateRow,
		handleRows,
		onEditRow,
		onSaveRow,
		onCancelEditRow,
		onDeleteRow,
		rowIndex
	} = props
	const isEditMode = rows[rowIndex].editMode
	
	return (
		<Grid container sx={{ width: '100%' }}>
			<Grid size={10}>
				<RowInputs
					rows={rows}
					row={row}
					rowIndex={rowIndex}
					handleRows={handleRows}
					isEditMode={isEditMode}
				/>
			</Grid>
			<Grid size={2}>
				{isEditMode ? (
					<>
						<IconButton
							color="success"
							onClick={() => {
								if (/^\d+$/.test(row?.id)) {
									onUpdateRow(rowIndex, row)
								} else {
									onSaveRow(rowIndex, row)
								}
							}}
						>
							<SaveIcon/>
						</IconButton>
						<IconButton
							color="error"
							onClick={() => onCancelEditRow(rowIndex, row)}
						>
							<TrashIcon/>
						</IconButton>
					</>
				) : (
					<>
						<IconButton
							color="primary"
							onClick={() => onEditRow(rowIndex, row)}
						>
							<EditIcon/>
						</IconButton>
						<IconButton
							color="primary"
							onClick={() => onDeleteRow(rowIndex, row)}
						>
							<TrashIcon/>
						</IconButton>
					</>
				)}
			</Grid>
		
		</Grid>
	)
};

export default Row